<template>
  <section class="site-noaside">
    <article class="content-area">
      <header class="page-header">
        <!--hide login link, add logout link -->
        <nav class="profile-nav">
          <router-link to="/about" class="button">About the Program</router-link>
          <button @click="logOut()" class="button">Log Out</button>
        </nav>
      </header>

      <main>
        <section class="content-header">
          <h2>My Information</h2>
        </section>

        <section class="content">
          <h3>My Lists</h3>

          <div class="list" v-for="session in sessions" :key="session.id">
            <h4 v-html="session.name" />
            <p class="small">Started on <span v-html="session.date" /></p>

            <button v-if="!session.finalized" @click="resume(session)">Resume</button>
            <button v-if="session.finalized" @click="view(session)">View</button>
          </div>

          <!-- always shows-->
          <div class="list">
            <button id="test-button" @click="creatingSession = true">Start a new list</button>
          </div>

          <!-- if start button is pressed-->
          <div class="list" id="newlist" v-if="creatingSession">
            <p>Name your list</p>
            <input type="text" placeholder="my question list" v-model="creatingSessionName" />
            <p class="small" v-html="today" />

            <button :class="newSessionButtonClass" @click="createNewSession(creatingSessionName)">Start my new
              list</button>
          </div>
        </section>

        <section class="content">
          <h3>My Account</h3>
          <p>If you want to change anything, please type in the boxes and press the Save button.</p>

          <div class="error" v-show="this.errors.length > 0">
            <ul>
              <li v-for="(error,index) in this.errors" :key="index" v-html="error" />
            </ul>
          </div>

          <p v-show="saved">Your changes have been saved.</p>

          <form class="account">
            <div class="group">
              <label class="col-md-4 control-label" for="email">Email Address</label>
              <input id="email" type="email" placeholder="you@example.com" class="form-control input-md"
                v-model="email" />
            </div>
            <div class="group">
              <label class="col-md-4 control-label" for="passwordinput">Change Password</label>
              <input id="passwordinput" name="passwordinput" type="password" placeholder="Type new password"
                class="form-control input-md" v-model="password1" />
              <label class="col-md-4 control-label" for="passwordinput">Type Your Password Again</label>
              <input id="passwordinput2" name="passwordinput2" type="password" placeholder="Type new password again"
                class="form-control input-md" v-model="password2" />
            </div>
            <div class="group">
              <label for="phone">Phone Number</label>
              <input id="phone" type="tel" placeholder="(999) 999-9999" v-model="phone" />
            </div>
            <button :class="saveButtonClass" @click="saveProfile">Save these edits</button>
            <!-- mike this button needs to work, if finished the placeholder class can go away-->
          </form>
        </section>
      </main>

      <site-footer></site-footer>
    </article>
  </section>
</template>

<style scoped lang="scss">
h3 {
  font-size: 1.6rem;
  font-family: "Karla", Helvetica Neue, Helvetica, Arial, sans-serif;
  font-weight: bold;
  color: #444;
  border-top: 2px solid #444;
  padding-top: 0.3em;
  margin: 0 0 1.3rem 0;
}

.content {
  margin: 1rem;

  @media (min-width: 600px) {
    margin: 0rem;

    +.content {
      margin-top: 2rem;
    }
  }
}

.list {
  border-top: 1px solid #9e9e9e;

  h4 {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0.5em 0;
  }

  button {
    margin: 1rem 0;
  }

  @media (min-width: 600px) {
    padding: 1rem 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1rem;
    align-items: center;

    input,
    h4 {
      grid-column: 1/3;
    }

    p.small {
      grid-column: 3/4;
      line-height: 1.1;
    }

    p {
      grid-column: 1/5;
      margin-bottom: 0;
    }

    button {
      margin-top: 0;
    }
  }
}

.help-block {
  font-style: italic;
  color: #158172;
}

.radio-inline {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;

  input {
    width: 2em;
  }
}

.form-group {
  display: flex;
  flex-wrap: wrap;

  label {
    display: flex;
    align-content: flex-start;
    padding-right: 2rem;

    input {
      margin: 0 1rem 0 0;
      flex: initial;
    }

    input[type="radio"],
    input[type="checkbox"] {
      width: auto;
      margin-right: 0.5rem;
    }
  }

  @media (max-width: 800px) {

    .radio,
    .checkbox {
      flex-basis: 100%;
    }
  }
}

input[type="submit"] {
  width: auto;
}

#test-button.active+#newList {
  display: block;
}
</style>

<script>
import SiteFooter from "@/components/SiteFooter.vue";
import { axios } from "@/main.js";
import { DateTime } from "luxon";
import { mapMutations } from "vuex";

export default {
  name: "Profile",
  components: {
    SiteFooter
  },
  data() {
    return {
      sessions: [],
      email: "",
      phone: "",
      creatingSession: false,
      creatingSessionName: "",
      saved: false,
      password1: "",
      password2: "",
      errors: []
    };
  },

  mounted() {
    this.updateSessionList();
    this.getProfile();
  },

  computed: {
    today() {
      return DateTime.fromJSDate(new Date()).toLocaleString(DateTime.DATE_MED);
    },
    newSessionButtonClass() {
      return this.creatingSessionName.length == 0 ? "muted-button" : "";
    },
    saveButtonClass() {
      if (this.saved) {
        return "";
      }
      else {
        return "placeholder";
      }
    }
  },

  methods: {
    ...mapMutations(["setArm", "setAccessCode", "setBaselineDateTime", "setServerChatSessionID", "setSessionFinalized", "resumeSession", "viewSession"]),

    startCreatingSession() {
      this.creatingSession = true;
      this.creatingSessionName = "";
    },
   
    logOut() {
      let logout_url = "/logout";

      axios
         .post(logout_url) 
         .then(function(response){
             let status = response.status
             if(status == 200) {
                 window.location.replace("/#/login");
             }
             else {
             console.log("Error trying to logout")
             }})              
    },

    createNewSession(name) {
      let sessions_url = "/api/chat/sessions/";
      let self = this;

      axios
        .post(sessions_url, {
          name: this.creatingSessionName,
          finalized: null,
          current_session_name: "situation"
        })
        .then(function (response) {


          self.updateSessionList();
          self.creatingSession = false;
        })
        .catch(function (error) {
          console.log(error);
          window.location.replace("/login");
        });
    },

    updateSessionList() {
      let sessions_url = "/api/chat/sessions/";
      let self = this;
      axios
        .get(sessions_url)
        .then(function (response) {
         
          self.sessions = [];
          for (let index in response.data) {
            let session = response.data[index];
            session.date = DateTime.fromISO(session.created).toLocaleString(
              DateTime.DATETIME_MED
            );
            self.sessions.push(session);
          }
        })
        .catch(function (error) {
          console.log(error);
          window.location.replace("#/login");
        });
    },

    saveProfile() {
      let profile_url = "/api/profile/";
      let self = this;

      var data = {
        'email': this.email,
        'new_phone': this.phone,
      };

      if (this.password1.length > 0 && this.password1 == this.password2) {
        data.password = this.password1;
      }

      this.errors = [];

      axios
        .put(profile_url, data)
        .then(function (response) {
          self.saved = true;
        })
        .catch(function (error) {
          console.log(error);
          self.errors = error.response.data;
        });;
    },

    getProfile() {
      let profile_url = "/api/profile/";
      let self = this;

      axios
        .get(profile_url)
        .then(function (response) {
          self.email = response.data["email"];
          self.phone = response.data["phone"];
          // self.setArm(response.data["arm"]);
          self.setAccessCode(response.data["access_code"]);
          self.setBaselineDateTime(response.data["baseline_datetime"]);
        })
        .catch(function (error) {
          console.log(error);
          window.location.replace("#/login");
        });
    },

    resume(session) {
      this.setServerChatSessionID(session.id);
      var summaryResponses = {};
      var chatResponses = {};

      let section = session.current_section_name || "situation";
      if (session.summary_responses.length > 0) {
        summaryResponses = JSON.parse(session.summary_responses);
      }

      if (session.chat_responses.length > 0) {
        chatResponses = JSON.parse(session.chat_responses);
      }

      this.resumeSession({
        sectionName: section,
        summaryResponses: summaryResponses,
        chatResponses: chatResponses
      });

      this.$router.push("/chat/" + section + "/new/");
    },
    view(session) {
      this.setServerChatSessionID(session.id);
      this.setSessionFinalized(new Date(session.finalized));

      var summaryResponses = {};
      var chatResponses = {};

      if (session.summary_responses.length > 0) {
        summaryResponses = JSON.parse(session.summary_responses);
      }

      if (session.chat_responses.length > 0) {
        chatResponses = JSON.parse(session.chat_responses);
      }

      this.viewSession({
        summaryResponses: summaryResponses,
        chatResponses: chatResponses
      });

      this.$router.push("/summary/locked/");
    }
  }
};
</script>
